import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsProducthuntComponent } from './simple-icons-producthunt.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsProducthuntComponent ],
    exports:      [ SimpleIconsProducthuntComponent ],
    bootstrap:    []
})
export class SimpleIconsProducthuntModule {}
